<template>
  <v-classification-toolbar
    title="Mapeo de valores"
    :classification="null"
    :classifications="[]"
    @toggle-sidebar="toggleSidebar"
  />
</template>

<script>
import { mapMutations } from "vuex";
import VClassificationToolbar from "@/components/toolbars/ClassificationToolbar.vue";

export default {
  components: {
    VClassificationToolbar
  },
  methods: {
    ...mapMutations("valueMapping", ["toggleSidebar"])
  }
};
</script>